import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommonService } from '../Services/common.service';
import { TranactionService } from '../Services/Transaction/transaction.service';
declare let $: any;
@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.css']
})
export class TransactionsComponent implements OnInit, OnDestroy {
  value: number;
  areTenSecsRemainings:boolean=false;
  timerValue:any;
  timerbutton:any=true;
  SubscriberauctionDetails: any=[];
  count: any;
  spinner:boolean=true;
  @Output('onComplete') count1: EventEmitter<any> = new EventEmitter<any>();
  id: any;
  stopInterval: boolean=false;
  SubscriberauctionData: any;
  bidOfferValidations: any= {};
  bidOfferForm:FormGroup;
  enablebidOfferModel: boolean=false;
  bidOfferDetails: Response;
  filterData: any;
  usermobileNo: string;
  auctionURL: any;
  constructor( private formBuilder: FormBuilder,private _commonservice: CommonService,private _tranactionService: TranactionService,private readonly http: HttpClient) {
    this.usermobileNo =sessionStorage.getItem('currentUser');
    let urldata = environment.apiURL;
    this.http.get(urldata).subscribe(res=>{
       this.auctionURL= res[1]['auctionURL'];
      });
   }

  ngOnInit() {
  
    this.stopInterval=true;
   this.timer();
   this.bidOfferForm = this.formBuilder.group({
    offerAmount: ['',Validators.required],
    subscriberName:[],
    branchName:[],
    groupcode:[],
    ticketno:[], 
    maxDiscount:[],
    minDiscount:[],
    auctionMonth:[]
    
  });
  this.BlurEventAllControll(this.bidOfferForm);

  }


  // timer(){
  //   let source$ = Observable.range(0, this.value).zip(
  //     Observable.timer(0, 1000),
  //     (x) => { return x }
  //   ).map(x => {
  //     return this.value - x

  //   })
  //   source$.subscribe(seconds => {
  //     // console.log(seconds)
  //     let mins = parseInt("" + seconds / 60);
  //     let secs = seconds % 60;
  //     let hrs = parseInt("" + mins / 60);
  //     mins = mins % 60
  //     if(secs<11) this.areTenSecsRemainings=true
  //     let res = {
  //       'hours': hrs,
  //       'minutes': mins,
  //       'seconds': secs
  //     }

  //     this.timerValue=res;
  //     if(this.timerValue.seconds == 1){
  //       this.timerOver();
  //     }
  //   }, )
  // }

  GetSubscriberauctionDetails() {
    this._tranactionService.GetSubscriberauctionDetails(this.usermobileNo).subscribe(json => {

      if (json != null) {
        this.SubscriberauctionDetails = json
        this.count = this.SubscriberauctionDetails.length;
        this.count1.emit(this.count);
        this.spinner=false;
      }
    },
      (error) => {
        this._commonservice.showErrorMessage(error);
      });
  }


  
  // timerOver(){
  //   this.timerbutton=false;
  // }

  timer(){
      setInterval(() => {
        if (this.stopInterval) 
        this.GetSubscriberauctionDetails();
      }, 1000);
  }

  ngOnDestroy() {
    this.stopInterval=false;
   this.timer();
  }
  participate(chitNo){

  window.open(this.auctionURL+'/#/Livebidding?id='+chitNo, '_blank', 'location=yes,scrollbars=yes,status=yes');
}

GetbidOffer(chitNo,vchgrpcode,auctmonth,vchbranchname){
  this.bidOfferForm.controls.offerAmount.setValue('');
  this.bidOfferValidations= {};
 this.filterData= this.SubscriberauctionDetails.filter(x=>x.chitno == chitNo)[0];
 this.bidOfferForm.controls.subscriberName.setValue(this.filterData["vchsubscribername"]);
  this.bidOfferForm.controls.groupcode.setValue(this.filterData["vchgrpcode"]);
  this.bidOfferForm.controls.ticketno.setValue(this.filterData["numticketno"].toString());
  this.bidOfferForm.controls.branchName.setValue(this.filterData["vchbranchname"]);
  this.bidOfferForm.controls.auctionMonth.setValue(this.filterData["auctmonth"].toString());
console.log(this.filterData);
  this._tranactionService.getmaxbidoffer(vchgrpcode,auctmonth,vchbranchname).subscribe(json => {

    if (json != null) {
      this.bidOfferDetails = json
      this.bidOfferForm.controls.maxDiscount.setValue(this.bidOfferDetails["maxDiscount"]);
      this.bidOfferForm.controls.minDiscount.setValue(this.bidOfferDetails["minDiscount"].split(".")[0]);
      console.log(this.bidOfferDetails);
    }
  },
    (error) => {
      this._commonservice.showErrorMessage(error);
    });
}

BlurEventAllControll(fromgroup: FormGroup) {
  // document.getElementById('lblstatus').innerHTML='';
   try {
     Object.keys(fromgroup.controls).forEach((key: string) => {
       this.setBlurEvent(fromgroup, key);
     })
   }
   catch (e) {
    // this.showErrorMessage(e);
     return false;
   }
 }
 setBlurEvent(fromgroup: FormGroup, key: string) {
   try {
     let formcontrol;
     formcontrol = fromgroup.get(key);
     if (formcontrol) {
       if (formcontrol instanceof FormGroup) {
         this.BlurEventAllControll(formcontrol)
       }
       else {
         if (formcontrol.validator)
           fromgroup.get(key).valueChanges.subscribe((data) => { this.GetValidationByControl(fromgroup, key, true) })
       }
     }
   }
   catch (e) {
    // this.showErrorMessage(e);
     return false;
   }
 }
 GetValidationByControl(formGroup: FormGroup, key: string, validate: boolean): boolean {
   try {
     let formcontrol;
     formcontrol = formGroup.get(key);
     if (formcontrol) {
       if (formcontrol instanceof FormGroup) {
         this.checkValidations(formcontrol, validate)
       }
       else if (formcontrol.validator) {
         this.bidOfferValidations[key] = '';
         if (formcontrol.errors || formcontrol.invalid || formcontrol.touched || formcontrol.dirty) {
           let lablename;
           lablename = (document.getElementById(key) as HTMLInputElement).title;
           let errormessage;
           for (const errorkey in formcontrol.errors) {
             if (errorkey) {
               errormessage = this._commonservice.getValidationMessage(formcontrol, errorkey, lablename, key, '');
               this.bidOfferValidations[key] += errormessage + ' ';
               validate = false;
             }
           }
         }
       }
     }
   }
   catch (e) {
     //this.showErrorMessage(e);
     return false;
   }
   return validate;
 }
 checkValidations(group: FormGroup, validate: boolean): boolean {

   try {
     Object.keys(group.controls).forEach((key: string) => {
       validate = this.GetValidationByControl(group, key, validate);
     })
   }
   catch (e) {
    // this.showErrorMessage(e);
     return false;
   }
   return validate;
 }

 SaveBidOfferAmount() {
  try {
    let validate = true;
   let amount= this._commonservice.removeCommasInAmount(this.bidOfferForm.controls.offerAmount.value);
    this.bidOfferForm.controls.offerAmount.setValue(amount.toString());
    if (this.checkValidations(this.bidOfferForm,validate) ) {
      const validData=  this.validateBidoffer();
      if(validData){
      let data = JSON.stringify(this.bidOfferForm.value);
            this._tranactionService.Savebidoffer(data).subscribe(res => {
              console.log(res);
              if (res) {
                alert(res["statusmsg"]);
                this.clear();
               $('#bidoffer').modal('hide');
               // this._commonservice.showSuccessMsg("Saved successfully");
                
                }
                
            },
              (error) => {
                 
               //this._commonservice.showErrorMessage(error);
               this._commonservice.showErrorMessage(error);
              });
    }
  }
  }
  catch (e) {
    this._commonservice.showErrorMessage(e);
    return false;
  }
}

clear(){
  this.bidOfferForm.reset();
  this.bidOfferValidations= {};
}

 validateBidoffer() {
  debugger;
  var offeramount = this.bidOfferForm.controls.offerAmount.value;
  var mindiscountamount = this.bidOfferForm.controls.minDiscount.value;
  var maxdiscountamount = this.bidOfferForm.controls.maxDiscount.value ;

  if (offeramount == null || offeramount == '') {
      alert('Enter Offer Amount');
      //jq('#lblmessage').text('Enter Offer Amount');
      return false;
  }
  else if (offeramount == 0) {
    this.bidOfferForm.controls.offerAmount.setValue('');
      //jq('#lblmessage').text('Zero Offer Amount Should not be Allowed');
      alert('Zero Offer Amount Should not be Allowed');
      return false;
  }

  if (parseInt(offeramount) == parseInt(maxdiscountamount)) {
      if (this.ValidBidofferAmount()) {
          return true;
      }
      else {
          return false;
      }
  }
  else if (parseInt(offeramount) <= parseInt(mindiscountamount) || parseInt(offeramount) > parseInt(maxdiscountamount)) {
    this.bidOfferForm.controls.offerAmount.setValue('');
      alert('Amount should be in between Maximum Bid Offer and Maximum Discount Allowed');
      return false;
  }
  else {
      if (this.ValidBidofferAmount()) {
          return true;
      }
      else {
          return false;
      }
  }
  return true;

 }

 ValidBidofferAmount() {
  var offeramount = this.bidOfferForm.controls.offerAmount.value;
  var lastDigit = String(offeramount).substr(-3);
  let lastdigits = parseInt(lastDigit)
  var x = lastdigits;
  var y = 100;
  var z = x % y;
  console.log("z", z)
  if (z == 0) {

  }
  else {
    this.bidOfferForm.controls.offerAmount.setValue('');
      //this.commonservice.showWarningMessage("Amount should be multiples of 100")
      alert('Offer Amount should be multiples of 100');
      return false;
  }
  return true;
}
}
